import { getUser, refreshToken } from "../../../helpers/auth";
import { Divider, Tag, message } from "antd";
import { IconChevronRight } from "@tabler/icons";
import { Avatar, Group, LoadingOverlay, Text } from "@mantine/core";
import { putSwitchFacility } from "../../../helpers/api";
import { useMutation } from "react-query";
import _ from "lodash";

const SwitchFacility = ({ onClose }) => {
  const user = getUser();

  const {
    mutateAsync: switchFacility,
    isLoading,
    isSuccess,
  } = useMutation((id) => putSwitchFacility(id), {
    onSuccess: (data) => {
      if (data.status === 200) {
        refreshToken().then(({ token, user }) => {
          if (user && token) {
            message.success("Facility switched successfully");
            window.location.reload();
          }
        });
      } else {
        throw data;
      }
    },
    onError: (error) => {
      const err = error?.response?.data?.message || error?.message;
      if (_.isArray(err)) {
        err.map((e) => message.error(e.message || e));
      } else {
        message.error(err || "Failed to switch facility");
      }
    },
  });

  const handleSwitch = (facilityId) => {
    const activeFacilityId = user?.facilityId || user?.facility?.id;

    if (facilityId === activeFacilityId) {
      message.error("Cannot switch to active facility");
      return;
    }

    switchFacility(facilityId);
  };

  // Get facilities from user token, including current facility
  const facilitiesFromToken = user?.facilities || [];
  const currentFacility = user?.facility;
  const activeFacilityId = user?.facilityId || user?.facility?.id;

  // Ensure current facility is included in the list
  let facilities = [...facilitiesFromToken];

  // If current facility exists and is not in the facilities array, add it
  if (currentFacility && activeFacilityId) {
    const hasCurrentFacility = facilities.some(
      (f) => f.id === activeFacilityId
    );
    if (!hasCurrentFacility) {
      // Get role from user or default
      const currentRole = user?.role || "user";
      facilities.push({
        id: currentFacility.id,
        facilityName: currentFacility.facilityName,
        role: currentRole,
        isMain: true, // Assume current is main if not in list
      });
    }
  }

  return (
    <div className="mt-3">
      <LoadingOverlay visible={isLoading || isSuccess} />
      <div>
        {/* <h6>Switch Facility</h6>
        <Divider className="mb-1" /> */}
        <p>
          Below are facilities you have access to. All unsaved work will be lost
          when you switch. Click to switch!
        </p>
        <Divider className="mt-1" />
        {facilities.length === 0 ? (
          <p className="text-muted">No facilities available</p>
        ) : (
          facilities.map((facility) => {
            const isActive = activeFacilityId === facility.id;
            return (
              <div key={facility.id} className="card mb-2">
                <Group
                  className={`p-2 ${isActive ? "" : "hover-hand"}`}
                  onClick={() => !isActive && handleSwitch(facility.id)}
                  style={{
                    cursor: isActive ? "not-allowed" : "pointer",
                    opacity: isActive ? 0.6 : 1,
                  }}>
                  <Avatar radius="xl">
                    <span className="bi bi-building"></span>
                  </Avatar>

                  <div style={{ flex: 1 }}>
                    <Text size="md" weight={500}>
                      {facility.facilityName}
                      {isActive && (
                        <Tag color="green" className="ms-3">
                          Active Facility
                        </Tag>
                      )}
                    </Text>
                    <Text size="xs" color="dimmed">
                      Role: {facility.role}
                    </Text>
                  </div>
                  {!isActive && <IconChevronRight size="1rem" />}
                </Group>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SwitchFacility;
